import {Pipe, PipeTransform} from '@angular/core';
import {OrderByPipe} from "ngx-pipes";

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  constructor(private orderByPipe: OrderByPipe) {
  }

  transform<T>(input: T[], softBy: string | string[] | ((a: T, b: T, ...any) => number), ...any): T[]
  {
    if (softBy instanceof Function) {
      return input.sort((a, b) => softBy(a, b, any));
    }
    return this.orderByPipe.transform(input, softBy);
  }
}


